export default defineAppConfig({
  tairo: {
    collapse: {
      navigation: {
        enabled: true,
        header: {
          component: '',
        },
        footer: {
          component: '',
        },
        items: [],
      },
      circularMenu: {
        enabled: true,
        tools: [],
      },
      toolbar: {
        enabled: true,
        showTitle: false,
        showNavBurger: false,
        tools: [],
      },
    },
  },
})
